// axiosConfig.js
import axios from "axios";

let showMaintenanceAlertFn;
let showUnauthorizedAlertFn;
let showForbiddenAlertFn;
let showNotFoundAlertFn;
let showServerErrorAlertFn;

export const injectAxiosAlertHandlers = ({ onMaintenance, onUnauthorized, onForbidden, onNotFound, onServerError }) => {
    showMaintenanceAlertFn = onMaintenance;
    showUnauthorizedAlertFn = onUnauthorized;
    showForbiddenAlertFn = onForbidden;
    showNotFoundAlertFn = onNotFound;
    showServerErrorAlertFn = onServerError;
};

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const message = error?.response?.data?.MESSAGE;
  
      if (!error.response) {
        // Handle network errors (e.g., timeout, DNS error, offline)
        console.error("Network or connection error:", error.message);
        // You can show a generic alert here
        showServerErrorAlertFn?.(true); // or a separate `showNetworkErrorAlertFn` if you define one
        return Promise.reject(error);
      }
  
      switch (status) {
        case 401:
          showUnauthorizedAlertFn?.(true);
          break;
        case 403:
          showForbiddenAlertFn?.(true);
          break;
        case 404:
          showNotFoundAlertFn?.(true);
          break;
        case 503:
          showMaintenanceAlertFn?.(true);
          break;
        default:
          if (status >= 500) {
            showServerErrorAlertFn?.(true);
          }
          break;
      }
  
      if (message?.toLowerCase() === "maintenance") {
        showMaintenanceAlertFn?.(true);
      }
  
      return Promise.reject(error);
    }
  );
  

export default axiosInstance;
